import styled from 'styled-components';
import { Loader } from 'src/common/components/Loader';
import { FC } from 'react';

const StyledLoader = styled(Loader)`
  width: 2.5rem;
  height: 2.5rem;
`;

const LoaderWrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Text = styled.h3`
  margin-top: 1rem;
`;

export interface ScreenScrapeLoaderProps {
  className?: string;
  text?: string;
}

export const ScreenScrapeLoader: FC<ScreenScrapeLoaderProps> = ({
  className,
  text = 'Proszę czekać',
}) => {
  return (
    <LoaderWrapper className={className}>
      <StyledLoader />
      <Text>{text}</Text>
    </LoaderWrapper>
  );
};
